<template>
<view class="block h-[100%] bg-[#fff] bg-slate-100">
<view class="header-container">
  <span @click="goToHome" class="logo-text">芝麻开花智能写作平台</span>
  <div class="header-actions">
    <el-button @click="showOrderQuery" class="order-download-btn" type="primary" size="default" plain>订单下载</el-button>
    
    <!-- 未登录显示登录按钮 -->
    <el-button v-if="!isLoggedIn" @click="showLoginDialog" class="login-btn" type="primary" size="default">登录</el-button>
    
    <!-- 已登录显示用户下拉菜单 -->
    <el-dropdown v-else @command="handleCommand" trigger="hover" class="user-dropdown">
      <div class="user-info-btn">
        <el-avatar :size="32" class="user-avatar">
          <el-icon><User /></el-icon>
        </el-avatar>
        <span class="user-name">{{ userDisplayName }}</span>
        <el-icon class="dropdown-icon"><ArrowDown /></el-icon>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="history">
            <el-icon><Document /></el-icon>
            <span>权益信息</span>
          </el-dropdown-item>
          <el-dropdown-item command="logout" divided>
            <el-icon><SwitchButton /></el-icon>
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</view>
<view class="flex justify-center pt-[80px] px-4">
  <view class="w-full max-w-[900px]">
  <!-- <h1 class="mt-[20px] text-[24px] lg:text-[30px] text-center lg:text-left">AI写作</h1> -->
  <h3 class="mb-[20px] mt-[10px] text-[14px] lg:text-base text-center lg:text-left">根据需求自动完成论文写作</h3>
  <view class="block bg-[#fff] p-[20px] lg:p-[40px] shadow-lg main-content">
    <!-- 移动端步骤条 -->
    <div class="lg:hidden mb-6">
      <div class="flex items-center justify-between mb-4">
        <div class="text-sm text-gray-600">步骤 {{active + 1}} / 4</div>
        <div class="text-sm font-medium">{{getStepTitle(active)}}</div>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-2">
        <div class="bg-blue-600 h-2 rounded-full transition-all duration-300" :style="{width: `${(active + 1) * 25}%`}"></div>
      </div>
    </div>
    
    <!-- 桌面端步骤条 -->
    <div class="hidden lg:block">
      <el-steps :active="active" finish-status="success">
        <el-step title="基本信息" />
        <el-step title="文献" />
        <el-step title="摘要" />
        <el-step title="大纲" />
      </el-steps>
    </div>
    
  <view class="mb-[20px] block text-center mt-[20px] lg:mt-[40px] mb-[20px] lg:mb-[40px] text-sm lg:text-base px-2">{{tipsList[active]}}</view>
<el-form :model="form" label-width="100px" class="w-full">
  <div v-if="active === 0"><FirstStep :form="form" :validation-state="validationState" /></div>
  <div v-if="active === 1"><ThreeStep :form="form" /></div>
  <div v-if="active === 2"><FourStep :form="form" :is-back-navigation="isBackNavigation" /></div>
  <div v-if="active === 3"><FiveStep :form="form" @update:catalogs="updateCatalogs" @update:loading="updateLoading" /></div>
</el-form>
<div class="button-container" v-if="active < 3">
  <div class="flex flex-col md:flex-row justify-end gap-3 button-wrapper">
    <el-button @click="back" v-if="active > 0" size="default" class="mobile-button" type="default">上一步</el-button>
    <el-button @click="next" size="default" class="mobile-button" type="primary">下一步</el-button>
  </div>
</div>
<div class="button-container" v-if="active === 3">
  <div class="flex flex-col md:flex-row justify-center gap-3 button-wrapper">
    <el-button @click="back" size="default" class="mobile-button" type="default" :disabled="stepLoading">上一步</el-button>
    <el-button @click="submit" size="default" class="mobile-button" type="success" :disabled="stepLoading" :loading="stepLoading">提交</el-button>
  </div>
</div>
  </view>
</view>
</view>
<ConfirmOrder :visible="confirmDialogVisible" @update:visible="confirmDialogVisible = $event" @payment-success="handlePaymentSuccess" @show-benefits="showBenefits" :order="orderData" :is-logged-in="isLoggedIn" :on-show-login="showLoginDialog" />
<OrderQuery :visible="orderQueryVisible" @update:visible="orderQueryVisible = $event" :preset-order-number="orderQueryOrderNumber" />
<LoginModal :visible="loginDialogVisible" @update:visible="loginDialogVisible = $event" @login-success="handleLoginSuccess" />
<OrderHistory :visible="orderHistoryVisible" @update:visible="orderHistoryVisible = $event" />
</view>
</template>
<script setup lang="ts">
import FirstStep from './firstStep.vue'
import ThreeStep from './threeStep.vue'
import FourStep from './fourStep.vue'
import FiveStep from './fiveStep.vue'
import ConfirmOrder from '@/components/ConfirmOrder.vue'
import OrderQuery from '@/components/OrderQuery.vue'
import LoginModal from '@/components/LoginModal.vue'
import OrderHistory from '@/components/OrderHistory.vue'
import { ref, watch, onMounted } from 'vue'
import { reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { User, ArrowDown, Document, SwitchButton } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { getUser, logout } from '@/api/api'

const router = useRouter()
const active = ref(0)
const confirmDialogVisible = ref(false)
const orderQueryVisible = ref(false)
const loginDialogVisible = ref(false)
const orderHistoryVisible = ref(false)
const isLoggedIn = ref(false)
const userDisplayName = ref('')
const orderQueryOrderNumber = ref('')
const isBackNavigation = ref(false)
const stepLoading = ref(false) // 步骤加载状态
const validationState = reactive({
  name: true,
  region: true,
  keywords: true,
});
const orderData = reactive({
  title: '',
  wordNumber: 0,
  orderNumber: '',
  content: '',
  keywords: [] as string[],
  literature: [] as any[],
  abstract: '',
  catalogs: [] as any[]
})
  
  const form = reactive({
    name: '', // 标题字段，直接在第一步输入
    region: '0', // 默认选中"国家开放大学毕业论文"
    keywords: [],
    literature: [],
    abstract: '', // 摘要
    wordNumber: 6000
  })

// 获取步骤标题的函数
const getStepTitle = (step: number) => {
  const titles = ['基本信息', '文献', '摘要', '大纲'] // 删除了第二步"标题"
  return titles[step] || ''
}

watch(() => form.name, (val) => {
  if(val) validationState.name = true;
});
watch(() => form.region, (val) => {
  if(val) validationState.region = true;
});
watch(() => form.keywords, (val) => {
  if(val && val.length > 0) validationState.keywords = true;
});

watch(form,
(newVal) => {
  console.log(newVal, 'form data')
}, {
  deep: true 
}
);

const back = () => {
  isBackNavigation.value = true
  if (active.value-- < 0) active.value = 3 // 总共4步变成3步
}

const next = () => {
  isBackNavigation.value = false
  if (active.value === 0) {
    validationState.name = !!form.name;
    if (form.name.length > 40) {
      ElMessage.warning('标题不能超过40个字');
      return;
    }
    validationState.region = !!form.region;
    validationState.keywords = !!form.keywords && form.keywords.length > 0;
    if (!validationState.name || !validationState.region || !validationState.keywords) {
      return;
    }
    // 直接跳过第二步，清空文献列表
    form.literature = []
  }
  if (active.value === 1) {
    // 原第三步：验证文献数量必须在8-20条之间
    if (!form.literature || form.literature.length < 8 || form.literature.length > 20) {
      ElMessage({
        message: '请选择8-20篇文献',
        type: 'warning',
      })
      return;
    }
    // 从文献页面前进到摘要页面时，清除摘要缓存以确保重新生成
    form.abstract = ''
  }
  if (active.value === 2) {
    if (!form.abstract) {
      ElMessage({
        message: '请输入摘要内容',
        type: 'warning',
      })
      return;
    }
  }
  if (active.value < 3) { // 原来是4步，现在是3步
    active.value++;
  }
}

const updateCatalogs = (catalogs: any[]) => {
  orderData.catalogs = catalogs;
};

const updateLoading = (loading: boolean) => {
  stepLoading.value = loading;
};

const submit = () => {
  orderData.title = form.name; // 直接使用第一步的标题字段
  orderData.wordNumber = form.wordNumber;
  orderData.orderNumber = '2000' + Date.now();
  orderData.content = ''; // 将content字段设为空字符串
  orderData.keywords = form.keywords;
  orderData.literature = form.literature;
  orderData.abstract = form.abstract;
  // catalogs数据已经通过updateCatalogs函数更新
  confirmDialogVisible.value = true;
}

const showOrderQuery = () => {
  orderQueryVisible.value = true;
}

const showLoginDialog = () => {
  loginDialogVisible.value = true;
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await getUser();
    if (response.data && response.data.code === 0 && response.data.data) {
      const userData = response.data.data;
      // 优先显示userName，如果为空则显示mobile
      userDisplayName.value = userData.userName || userData.mobile || '已登录';
      isLoggedIn.value = true;
    } else if (response.data && response.data.code === -3) {
      // token失效，清除token
      localStorage.removeItem('token');
      userDisplayName.value = '';
      isLoggedIn.value = false;
    }
  } catch (error) {
    console.error('获取用户信息失败:', error);
    // 如果获取失败，清除token
    localStorage.removeItem('token');
    userDisplayName.value = '';
    isLoggedIn.value = false;
  }
}

const handleLoginSuccess = async () => {
  isLoggedIn.value = true;
  loginDialogVisible.value = false; // Close modal on success
  // 登录成功后获取用户信息
  await fetchUserInfo();
}

// 处理下拉菜单命令
const handleCommand = (command: string) => {
  if (command === 'history') {
    showOrderHistory();
  } else if (command === 'logout') {
    handleLogout();
  }
}

// 显示历史订单
const showOrderHistory = () => {
  orderHistoryVisible.value = true;
}

// 从支付弹窗查看累计折扣及权益档位
const showBenefits = () => {
  confirmDialogVisible.value = false;
  orderHistoryVisible.value = true;
}

// 退出登录
const handleLogout = async () => {
  try {
    await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    });
    
    try {
      const response = await logout();
      if (response.data && response.data.code === 0) {
        // 清除本地token
        localStorage.removeItem('token');
        isLoggedIn.value = false;
        userDisplayName.value = '';
        ElMessage.success('退出登录成功');
      } else {
        ElMessage.error(response.data?.msg || '退出登录失败');
      }
    } catch (error) {
      // 即使接口调用失败，也清除本地token
      localStorage.removeItem('token');
      isLoggedIn.value = false;
      userDisplayName.value = '';
      ElMessage.warning('已退出登录');
    }
  } catch {
    // 用户取消操作
  }
}

const handlePaymentSuccess = (orderNumber: string) => {
  // 支付成功后，设置订单号并显示订单查询弹窗
  orderQueryOrderNumber.value = orderNumber;
  orderQueryVisible.value = true;
}

const goToHome = () => {
  router.push('/')
}

onMounted(async () => {
  if (localStorage.getItem('token')) {
    // 如果有token，获取用户信息
    await fetchUserInfo();
  }
})

const tipsList = ['填写基本信息，包括标题、类型、关键词和字数预估', '请粘贴或选择相关文献，需要8-20篇', '请确认摘要内容', '请确定好论文大纲（可修改）']

</script>

<style scoped>
/* 头部样式 */
.header-container {
  width: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  padding: 16px 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.logo-text {
  cursor: pointer;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo-text:hover {
  transform: translateY(-2px);
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.order-download-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
  font-weight: 500;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.order-download-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}

.login-btn {
  background: #ffffff;
  color: #667eea;
  font-weight: 600;
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
  background: #f0f0f0;
}

.user-dropdown {
  cursor: pointer;
}

.user-info-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.user-info-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
}

.user-avatar {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.user-name {
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-icon {
  color: #ffffff;
  font-size: 14px;
}

:deep(.el-dropdown-menu__item) {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

:deep(.el-dropdown-menu__item:hover) {
  background: #f5f7fa;
  color: #667eea;
}

:deep(.el-dropdown-menu__item .el-icon) {
  font-size: 16px;
}

/* 移动端头部样式优化 */
@media (max-width: 768px) {
  .header-container {
    padding: 12px 16px;
  }
  
  .logo-text {
    font-size: 14px;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .header-actions {
    gap: 8px;
  }
  
  .order-download-btn {
    font-size: 12px;
    padding: 6px 12px;
  }
  
  .login-btn {
    font-size: 12px;
    padding: 6px 16px;
  }
  
  .user-info-btn {
    padding: 4px 12px;
  }
  
  .user-avatar {
    width: 28px !important;
    height: 28px !important;
  }
  
  .user-name {
    font-size: 12px;
    max-width: 60px;
  }
}

/* 移动端全局样式优化 */
@media (max-width: 768px) {
  /* 确保表单在移动端有合适的间距 */
  :deep(.el-form-item) {
    margin-bottom: 16px;
  }
  
  /* 移动端标签宽度调整 */
  .w-full :deep(.el-form) {
    --el-form-label-width: 80px;
  }
  
  /* 优化按钮在移动端的显示 */
  :deep(.el-button) {
    font-size: 14px;
    padding: 8px 16px;
  }
  
  /* 优化选择器在移动端的显示 */
  :deep(.el-select) {
    width: 100%;
  }
  
  /* 优化文本域在移动端的显示 */
  :deep(.el-textarea__inner) {
    font-size: 14px;
    line-height: 1.5;
  }
  
  /* 优化对话框在移动端的显示 */
  :deep(.el-dialog) {
    margin: 5vh auto !important;
    max-width: 90vw;
  }
  
  :deep(.el-dialog__body) {
    padding: 16px;
  }
  
  /* 优化步骤条在移动端的显示 */
  :deep(.el-steps) {
    padding: 0 16px;
  }
  
  :deep(.el-step__title) {
    font-size: 12px;
  }
}

/* 确保内容区域在移动端有合适的边距 */
@media (max-width: 640px) {
  .px-4 {
    padding-left: 12px;
    padding-right: 12px;
  }
}

/* 超小屏幕标签宽度调整 */
@media (max-width: 480px) {
  .w-full :deep(.el-form) {
    --el-form-label-width: 70px;
  }
}

/* 按钮容器样式 */
.button-container {
  margin-top: 24px;
  padding: 0 16px;
}

.mobile-button {
  min-width: 100px;
  height: 36px;
  font-size: 13px;
  font-weight: 500;
}

/* 平板端按钮样式 */
@media (max-width: 1024px) and (min-width: 769px) {
  .button-container {
    margin-top: 18px;
    padding: 0 10px;
  }
  
  .mobile-button {
    min-width: 90px;
    height: 34px;
    font-size: 12px;
  }
}

/* 移动端按钮样式 */
@media (max-width: 768px) {
  .button-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid #e4e7ed;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    display: flex;
    justify-content: center;
    z-index: 1000;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
  }
  
  .button-wrapper {
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    align-items: center;
    flex-wrap: nowrap;
    gap: 16px !important;
    width: 100%;
    max-width: 400px;
  }
  
  .mobile-button {
    flex: 1;
    max-width: 160px;
    min-width: 100px;
    height: 44px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
  }
  
  .mobile-button:active {
    transform: scale(0.98);
  }
  
  /* 为页面底部留出空间 */
  .main-content {
    margin-bottom: 100px !important;
    padding-bottom: 20px !important;
  }
}

/* 小屏幕手机样式 */
@media (max-width: 480px) {
  .button-container {
    padding: 10px 12px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }
  
  .button-wrapper {
    gap: 12px !important;
  }
  
  .mobile-button {
    height: 42px;
    font-size: 15px;
    min-width: 90px;
  }
}
</style>
